import React, { FunctionComponent } from 'react';

import { StandardDatePickerProps } from '@components/library/date-picker';

import { BaseDatePicker } from '../base';

import classes from './standard-date-picker.module.scss';

export const StandardDatePicker: FunctionComponent<StandardDatePickerProps> = (props) => (
  <BaseDatePicker
    {...props}
    actionsProps={{
      className: classes['standard-date-picker__actions'],
      ...props?.actionsProps
    }}
    calendarIconButtonProps={{
      className: classes['standard-date-picker__calendar-icon-button'],
      ...props?.calendarIconButtonProps
    }}
    calendarProps={{
      className: classes['standard-date-picker__calendar'],
      ...props?.calendarProps
    }}
    datePickerProps={{
      className: classes['standard-date-picker'],
      ...props?.datePickerProps
    }}
    dialogProps={{
      className: classes['standard-date-picker__dialog'],
      ...props?.dialogProps
    }}
    gridCellProps={{
      className: classes['standard-date-picker__grid-cell'],
      ...props?.gridCellProps
    }}
    gridColumnHeaderProps={{
      className: classes['standard-date-picker__grid-column-header'],
      ...props?.gridColumnHeaderProps
    }}
    gridProps={{
      className: classes['standard-date-picker__grid'],
      ...props?.gridProps
    }}
    headerProps={{
      className: classes['standard-date-picker__header'],
      ...props?.headerProps
    }}
    inputWrapperProps={{
      className: classes['standard-date-picker__input-wrapper'],
      ...props?.inputWrapperProps
    }}
    textfieldProps={{
      className: classes['standard-date-picker__textfield'],
      ...props?.textfieldProps
    }}
    todayProps={{
      className: classes['standard-date-picker__today'],
      ...props?.todayProps
    }}
    variantName="standard"
  />
);
